import React, { useState } from "react";
import { Trash2 } from "lucide-react";
import ConfirmDialog from "components/ConfirmDialog";

/**
 * WithdrawButton (SOUND-493)
 * -------------------------------------------------------
 * The client/partner's single status action. Non-internal callers may only
 * transition a ticket to `withdrawn` (the API 403s anything else), so they
 * never see a status menu — just this one ConfirmDialog-gated button. The
 * caller renders it only while the request is still open
 * (statusCategory ∈ {todo, in_progress}).
 */
export default function WithdrawButton({ onWithdraw, submitting = false }) {
  const [confirmOpen, setConfirmOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        className="btn btn-outline"
        onClick={() => setConfirmOpen(true)}
        disabled={submitting}
      >
        <Trash2 className="h-4 w-4" />
        Withdraw request
      </button>

      <ConfirmDialog
        open={confirmOpen}
        title="Withdraw this request?"
        description="This closes the request. Your team at Sound will see it's been withdrawn. You can always open a new request later."
        confirmLabel="Withdraw request"
        variant="destructive"
        onCancel={() => setConfirmOpen(false)}
        onConfirm={() => {
          setConfirmOpen(false);
          onWithdraw?.();
        }}
      />
    </>
  );
}
